import { combineReducers } from 'redux';
import softwareProducts from './softwareProducts';
import hardwareProducts from './hardwareProducts';
import invoices from './invoices';
import details from './details';
import contacts from './contacts';
import shippingOrders from './shippingOrders';
import workOrders from './workOrders';
import orderProducts from './orderProducts';

const reducer = combineReducers({
    softwareProducts,
    hardwareProducts,
    invoices,
    details,
    contacts,
    shippingOrders,
    workOrders,
    orderProducts
});

export default reducer;
